import getLayout from './get-modal-layout';
import Modal from './modal';

const classNames = {
  footer: {
    static: `page-footer--static`
  }
};

//TODO: refactor modals creation
class ModalHousePlan extends Modal {
  constructor() {
    super();
    this.toggle = this.page.querySelector(`.js-gallery-house`);
    this.footer = this.page.querySelector(`.page-footer`);
    this.plan = ``;
  };

  init(plans, locale) {
    super.createModal();
    this.plan = plans["plans"][0][`house_plan_${locale}`] || plans["plans"][0][`house_plan`];
    this.locale = locale;
    this.createModalWrap();
    this.bindHandlers();
  };

  createModalWrap() {
    super.addLayout(getLayout(`flat-house-plan`));
    this.createPlan();
  };

  createPlan() {
    const wrap = this.page.querySelector(`#house-plan`);
    const content = document.createElement(`div`);
    const planLayout = () => {
      return `<div class="modal-floors__floor">
                <img src="${this.plan}" alt="Квартира на плане дома">
              </div>`
    };
    content.className = `modal-floors__slider modal-slider`;
    content.innerHTML = planLayout();
    wrap.appendChild(content);
  };

  bindHandlers() {
    this.toggle.addEventListener(`click`, (ev) => {
      ev.preventDefault();

      this._toggleModal(true);
    });
  };
}

const modalHousePlan = new ModalHousePlan();

export default modalHousePlan;
